import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../common/http/http-utils';
import { ClientUtilities } from '../utils/client-utils';

@Injectable()
export class FeatureEnablementService {

    public isRunningInNGC: boolean = false;
    private apiBase: string;
    private featureEnablementApi: string;
    private hcxDetailsQuery = '/hybridity/api/metainfo/context/hcxconfig';

    constructor(public http: HttpClient) {
        this.isRunningInNGC = ClientUtilities.runningInPluginUI();

        const path = (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1];
        this.apiBase = (!!path && !!this.isRunningInNGC) ? path + '/hcx-ui/rest' : '';
        
        this.featureEnablementApi = this.apiBase + '/hybridity/api/featureConfig';
    }

    public getFeatureEnablement(vcGuid: string, payload: object) {
        return this.http.post(HttpUtils.getBaseUrl() + this.featureEnablementApi + '?vcGuid=' + vcGuid + '&action=query',
            payload);
    }

    public getNsxConfig(vcGuid: string) {
        const URL = HttpUtils.getBaseUrl() + this.apiBase + this.hcxDetailsQuery +  '?sections=nsx&vcGuid=' + vcGuid;
        return this.http.get(URL);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/feature-enablement.service.ts